import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

import type { JSX } from 'react';
import { useDesignSystemEnabled } from '../theme/useDesignSystemEnabled';
import { DesignSystemTextField } from './textFieldDesignSystem';

export type TextFieldProps = Omit<MuiTextFieldProps, 'variant'> & {
  // Define the allowed variants explicitly:
  variant?: 'standard' | 'outlined' | 'filled';
  dataTest?: string;
  'data-test'?: string;
  /** Forces the design-system (`true`) or legacy (`false`) version; defaults to the `ui-design-system` GrowthBook feature. */
  designSystem?: boolean;
};

export const TextField = ({ dataTest, slotProps, designSystem, ...props }: TextFieldProps): JSX.Element => {
  const isDesignSystem = useDesignSystemEnabled('textField', designSystem);

  if (isDesignSystem) {
    return <DesignSystemTextField {...props} dataTest={dataTest || props['data-test']} slotProps={slotProps} />;
  }

  return (
    <MuiTextField
      data-test={dataTest || props['data-test']}
      variant="standard"
      slotProps={{
        ...(props.variant !== 'outlined' && { input: { disableUnderline: true } }),
        inputLabel: { disableAnimation: true, focused: false, shrink: true },
        ...slotProps,
      }}
      {...props}
    />
  );
};
